import React, { FC } from 'react';

import { Button, ContainerProps } from '@lglp/components';

import { withTrackingEvent } from '../../components/mixins/seo';

const ShareButton: FC<ShareButtonProps> = ({
  title,
  url,
  icon: Icon,
  track,
  name: LabelGA,
  className,
}) => {
  const onClick = (): void => {
    track({
      categoryGA: 'Social',
      actionGA: 'SocialNetworkShare',
      LabelGA,
    });
    window.open(
      url,
      title,
      'left=660,top=146,width=600,height=359,personalbar=0,toolbar=0,scrollbars=1,resizable=1'
    );
  };

  return (
    <Button title={title} className={className} onClick={onClick}>
      <Icon className="share-button-icon" />
    </Button>
  );
};

type ShareButtonProps = ContainerProps & {
  title: string;
  url: string;
  icon: React.ElementType;
  track: ((arg: any) => any) | (() => null);
  name: string;
};

export default withTrackingEvent(ShareButton);
